import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { colors } from '@/colors';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const TooltipContentWrapper = styled.div`
  position: fixed;
  z-index: 9999;
`;

export const TooltipContent = styled.div`
  z-index: 1;
  padding: 8px;
  box-shadow: 0px 1px 8px 0px rgba(112, 114, 125, 0.6);
  border-radius: 4px;
  background-color: ${colors.AJAIB_BLUE_9};
  color: ${colors.NEUTRAL_0};
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  transition: opacity 0.3s;
  pointer-events: none;
  box-sizing: border-box;
  max-width: 256px;
  ${({ show }) => css`
      animation: ${show ? fadeIn : fadeOut} 0.2s ease-in-out forwards;
    `}
`;

export const Arrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  margin: 5px;
  ${({ show }) => css`
      animation: ${show ? fadeIn : fadeOut} 0.2s ease-in-out forwards;
    `}

  &[data-placement*='bottom'] {
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent ${colors.AJAIB_BLUE_9} transparent;
    top: -6px;
    margin-top: 0;
    margin-bottom: 0;
  }
  &[data-placement*='top'] {
    border-width: 6px 6px 0 6px;
    border-color: ${colors.AJAIB_BLUE_9} transparent transparent transparent;
    bottom: -6px;
    margin-top: 0;
    margin-bottom: 0;
  }
  &[data-placement*='right'] {
    border-width: 6px 6px 6px 0;
    border-color: transparent ${colors.AJAIB_BLUE_9} transparent transparent;
    left: -6px;
    margin-left: 0;
    margin-right: 0;
  }
  &[data-placement*='left'] {
    border-width: 6px 0 6px 6px;
    border-color: transparent transparent transparent ${colors.AJAIB_BLUE_9};
    right: -6px;
    margin-left: 0;
    margin-right: 0;
  }
`;
